import { createStyles } from '@material-ui/core';
import { toCssValue } from '@topconagriculture/theme';
const styles = (theme) => createStyles({
    root: {
        height: '100vh',
        backgroundColor: theme.color.background.light,
        width: 110,
        position: 'absolute',
        top: 0,
        left: 0,
        margin: 0,
        lineHeight: '20px',
        boxShadow: '7px 0 20px -15px black',
        boxSizing: 'border-box',
        transform: 'translateX(-100%)',
        transition: 'all 300 linear',
        paddingTop: 80,
        zIndex: 1099,
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
    },
    show: {
        transform: 'translateX(0)',
    },
    closed: {
        boxShadow: 'none',
    },
    appItem: {
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: 80,
        cursor: 'pointer',
        textTransform: 'uppercase',
        textAlign: 'center',
        textDecoration: 'none',
        width: '100%',
        '&:hover': {
            backgroundColor: theme.color.grey.lightest,
        },
        padding: 10,
    },
    appItemActive: {
        backgroundColor: theme.color.grey.lightest,
        borderLeft: `8px solid ${theme.components.sidebar.colors.itemSelected}`,
        textDecoration: 'none',
        textAlign: 'center',
    },
    nameActive: {
        fontWeight: theme.font.weight.bold,
    },
    appItemImg: {
        display: 'block',
        margin: '0 auto',
        marginBottom: 7,
        marginTop: 2,
        width: 35,
    },
    appVersion: {
        flex: 1,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        padding: 2,
        fontSize: theme.font.size.small,
    },
    itemLabel: {
        color: theme.color.font.dark,
        fontSize: 11,
        lineHeight: 1.2,
        padding: toCssValue([0, 10]),
    },
});
export default styles;
//# sourceMappingURL=SidebarStyles.js.map